export var ActionResult;
(function (ActionResult) {
    ActionResult[ActionResult["Remove"] = 0] = "Remove";
    ActionResult[ActionResult["Keep"] = 1] = "Keep";
})(ActionResult || (ActionResult = {}));
;
